import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./app/App";
import { installPublicWebVitalsReporter } from "./shared/perf/web-vitals";
import "./styles/tokens.css";
import "./styles/global.css";
import "./styles/native-surfaces.css";

const root = document.getElementById("root");
if (!root) throw new Error("root element missing");

installPublicWebVitalsReporter();

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
